import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Table from './Table'
import { actions } from '../../../../../store'

const mapStateToProps = state => ({
  status: state.modal.storageUploadModal,
  uploadedFiles: state.upload.uploadedFiles,
  uploadedTable: state.upload.uploadedTable,
  acceptedFiles: state.upload.acceptedFiles
})

const mapDispatchToProps = dispatch => bindActionCreators({
  removeUploadedFile: actions.upload.removeUploadedFile,
  deleteStorageResourceById: actions.storage.deleteStorageResourceById,
  updateUploadedTableById: actions.upload.updateUploadedTableById,
  updateUploadedTable: actions.upload.updateUploadedTable
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Table)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUploadModal/components/Table/index.js